module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    class: _vm.textClasses,
    attrs: {
      "tabindex": "0",
      "href": "#"
    },
    on: {
      "mouseover": function($event) {
        _vm.active = true
      },
      "mouseout": function($event) {
        _vm.active = false
      }
    }
  }, [_vm._t("suggestion", [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.htmlText)
    }
  })], null, {
    data: _vm.data,
    htmlText: _vm.htmlText
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ef2d9642"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-bootstrap-typeahead/src/components/VueBootstrapTypeaheadListItem.vue
// module id = 1169
// module chunks = 5